import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { sendTrainingEmail } from 'api/actions/userMetadata/userMetadataActions'
import { Mutations } from 'api/mutations.enum'
import {
    SendTrainingEmailErrorResponse,
    SendTrainingEmailPayload,
} from 'api/actions/userMetadata/userMetadataActions.types'

export const useSendTrainingEmail = () => {
    const mutation = useMutation<void, AxiosError<SendTrainingEmailErrorResponse>, SendTrainingEmailPayload>({
        mutationKey: [Mutations.sendTrainingEmail],
        mutationFn: sendTrainingEmail,
    })

    return mutation
}
